export const getCableInfo = (cable: any) => ({
  circuit: cable?.circuit,
  breaker: cable?.breaker,
  cableSpec: cable?.cableSpec || cable?.cableSize,
  cableType: cable?.lvCableMatchName,
  cableReasoning: cable?.cableReasoning,
  destination: cable?.destination,
  sourceName: cable?.sourceName,
  destinations: { reachable: 0, total: 0 },
  sharedTrunkPercentage: cable?.sharedTrunkPercentage || 0,
});
